import { Button } from "@carbon/react";
import { t } from "i18next";
import React from "react";
import { toast } from "react-hot-toast";
import { Translation } from "react-i18next";
import ErrorMessage from "./ErrorMessage";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, details: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, details: error };
  }

  componentDidCatch(error, errorInfo) {
    console.log(error, errorInfo);
    if (this.props.empty) {
      toast.error(t("something_went_wrong"));
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <>
          {!this.props.empty ? (
            <>
              <ErrorMessage
                message={this.props.customText}
                heading={t("something_went_wrong")}
              />

              <Button
                onClick={() => window.location.reload(false)}
                className="mt-100"
                size="md"
              >
                <Translation>{(t) => t("reload_the_page")}</Translation>
              </Button>
            </>
          ) : null}
        </>
      );
    }

    return this.props.children;
  }
}
